<div class="wrapper main-body mt-5 px-4">
    <div class="example-container d-flex flex-column w-100">
        <!-- Top Search & Header -->
        <div class="d-flex justify-content-between align-items-end flex-wrap mb-3">
            <!-- Search Bar -->
            <div class="containersearch d-flex mb-3 size">
                <input
                    id="search"
                    matInput
                    [(ngModel)]="filterValue"
                    (ngModelChange)="applyFilter()"
                    type="text"
                    placeholder="Search by competency, Client name, etc..."
                    class="form-control IncreaseWidth"
                >
            </div>
            <div class="d-flex align-items-center gap-3 flex-wrap size" style="justify-content: end;">
                <div class="tab-box total-count CardSize" style="background-color: #e2eaf7">
                    <div class="tab-count">{{ totalAudits }}</div>
                    <div class="tab-title">Total</div>
                </div>
                <div class="tab-box CardSize" style="background-color: #e2f1f7">
                    <div class="tab-count">{{ auditRequestSubmittedCount }}</div>
                    <div class="tab-title">Request Submitted</div>
                </div>
                <div class="tab-box CardSize" style="background-color: #f7ece2">
                    <div class="tab-count">{{ auditInitiatedCount }}</div>
                    <div class="tab-title">Initiated</div>
                </div>
                <div class="tab-box CardSize" style="background-color: #f0e2f7">
                    <div class="tab-count">{{ auditCompletedCount }}</div>
                    <div class="tab-title">Completed</div>
                </div>
                <button
                    mat-flat-button
                    color="primary"
                    class="custom_btn primary_btn_base btnSize"
                    *ngIf="showCreateAuditButton"
                    routerLink="/Home/Audit/CreateAudit"
                >
                    + Create Audit
                </button>
            </div>
        </div>

        <div class="custom_heading1">
            <span>Audits</span>
        </div>

        <!-- Table -->
        <div class="mat-elevation-z2">
            <mat-table [dataSource]="dataSource" matSort class="audit-table">
                <ng-container matColumnDef="id">
                    <mat-header-cell *matHeaderCellDef> ID </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{ row.id }} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef> Project Name </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{ row.name }} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="manager">
                    <mat-header-cell *matHeaderCellDef> Manager </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{ row.managerName }} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="auditor">
                    <mat-header-cell *matHeaderCellDef> Auditor </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{ row.auditorName }} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="client">
                    <mat-header-cell *matHeaderCellDef> Client </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{ row.clientName }} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="audit-start-date">
                    <mat-header-cell *matHeaderCellDef> Start Date </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{ row.expectedAuditStartDate }} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="stage">
                    <mat-header-cell *matHeaderCellDef> Stage </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{ row.statusName }} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Actions/View">
                    <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        <ng-container *ngIf="row.statusId == 4">
                            <ng-container *ngIf="loggedInEmployeeId == 100867; else inProgress">
                                <a
                                    class="text-primary text-decoration-underline cursor-pointer"
                                    (click)="view(row)"
                                >Select Categories</a>
                            </ng-container>
                            <ng-template #inProgress>
                                <span>Selection in Progress</span>
                            </ng-template>
                        </ng-container>
                        <ng-container *ngIf="row.statusId > 4">
                            <span
                                class="material-symbols-outlined icon"
                                (click)="navigateToProjectOverview(row.id, row.auditorId)"
                            >visibility</span>
                        </ng-container>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row
                    [class.odd]="i % 2 == 1"
                    [class.even]="i % 2 == 0"
                    *matRowDef="let row; columns: displayedColumns; let i = index;"
                >
                </mat-row>
            </mat-table>
            <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 50, 100]"></mat-paginator>
        </div>
    </div>
</div>